import { render } from "./CleanRoom.vue?vue&type=template&id=713060b6"
import script from "./CleanRoom.vue?vue&type=script&lang=js"
export * from "./CleanRoom.vue?vue&type=script&lang=js"
script.render = render

export default script